import React from 'react';
import { useAlert } from 'react-alert';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { Button, Form, FormControl, H1, InputError, Link } from '../../assets/styles/GlobalStyles';
import { verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import { translate } from '../../i18n/index';
import { forgotPasswordUser } from "../../services/services";

const ForgotPassword = ({ history }) => {
    const alert = useAlert();

    function handleClickForgotPassword() {
        history.push({
            pathname: '/login',
            search: history.location.search,
        });
    }

    return (
        <Base>
            <ContentContainer>
                <Formik
                    enableReinitialize
                    initialValues={{
                        username: '',
                    }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required(translate('validateRequired')),
                    })}
                    onSubmit={async (values, actions) => {
                        if (values) {
                            try {
                                const sendObj = {
                                    ...values,
                                    sourceRequest: 'imilk',
                                    typeRecovery: 'email'                                    
                                }
                                
                                const forgotPasswordResponse = await forgotPasswordUser(sendObj);

                                 if (forgotPasswordResponse) {
                                    const success = forgotPasswordResponse.status === 200
                                    alert.show(success ? translate('passwordSentSuccess') : forgotPasswordResponse.data, {
                                        closeCopy: 'Fechar',
                                    })

                                    if (success) {
                                        handleClickForgotPassword()
                                    }
                                } 
                            } catch (e) {
                                if (e.code === 'InvalidParameterException') {
                                    alert.show(translate('forgotPasswordExceptionContactVerifiedRequired'), {
                                        closeCopy: 'Fechar',
                                    });
                                } else {
                                    alert.show(verifyError(e.code, e.message), {
                                        closeCopy: 'Fechar',
                                    });
                                }
                            }
                        }
                        actions.setSubmitting(false);
                    }}>
                    {({ isSubmitting }) => (
                        <Form>
                            <H1
                                style={{
                                    marginBottom: '20px',
                                    lineHeight: '25px',
                                    fontSize: '15px',
                                }}>
                                {translate('forgotPasswordTitle')}
                            </H1>
                            <FormControl>
                                <Field
                                    autocapitalize="off"
                                    name="username"
                                    placeholder={translate('inputUsername')}
                                    component={Input}
                                />
                                <ErrorMessage name="username" component={InputError} />
                            </FormControl>
                            <FormControl>
                                <Button type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                                </Button>
                                <FormControl>
                                    <Link
                                        to={{
                                            pathname: '/login',
                                            search: history.location.search,
                                        }}>
                                        {translate('buttonBack')}
                                    </Link>
                                </FormControl>
                            </FormControl>
                        </Form>
                    )}
                </Formik>
            </ContentContainer>
        </Base>
    );
};

export default ForgotPassword;
